<template>
  <div class="wrapper">
    <parallax class="section page-header header-filter" :style="headerStyle"></parallax>
    <div class="main main-raised">
      <div class="section profile-content">
        <div class="container">
          <div class="md-layout">
            <div class="md-layout-item md-size-50 mx-auto">
              <div class="profile">
                <div class="avatar">
                  <img :src="img" alt="Circle Image" class="img-raised rounded-circle img-fluid">
                </div>
                <div class="name">
                  <h3 class="title">No Lo Olvides!</h3>
                  <h6>Política de Privacidad</h6>
                  <h7>Última modificación: 9 de septiembre de 2019</h7>
                </div>
              </div>
            </div>
          </div>
          <div class="description text-center">
            <p>
              No lo olvides!, es la app que te ayuda en tus quehaceres diarios.
              <br>Puedes elegir cualquier imagen de fondo, de las que tengas en tu galería. Darle zoom, elegir color, tipo de letras (se irán agregando mas), borrarlas todas, o solo una.
            </p>
          </div>
          <div>
              Cuando utilizas esta aplicacion, compartes ciertos datos con nosotros. Este documento te explica que informacion compartes. Leelo con cuidado.
              <br>
              <h3><strong>Información que recabamos</strong></h3>
              <h4><strong>Información que tu decides compartir con nosotros</strong></h4>
              Ninguna información es recabada
              <h4><strong>Información que tu nosotros recolectamos</strong></h4>
              En la version free, recabamos el uso de la app gracias a los ADS o PUBLICIDAD.
              <br><br>
              <strong>Finalmente, recordamos que tus recordatorios o imagenes utilizadas no salen de tu dispositivo, se mantienen en el, nosotros no almacenamos nada!.</strong>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Tabs } from "@/components";
export default {
  components: {
    Tabs
  },
  bodyClass: "profile-page",
  data() {
    return {};
  },
  props: {
    header: {
      type: String,
      default: require("@/assets/img/bg23.jpg")
    },
    img: {
      type: String,
      default: require("@/assets/img/portfolio/logo_noloolvides2.png")
    }
  },
  computed: {
    headerStyle() {
      return {
        backgroundImage: `url(${this.header})`
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.section {
  padding: 0;
}

.profile-tabs /deep/ {
  .md-card-tabs .md-list {
    justify-content: center;
  }

  [class*="tab-pane-"] {
    margin-top: 3.213rem;
    padding-bottom: 50px;

    img {
      margin-bottom: 2.142rem;
    }
  }
}
</style>
